<span class="inline-block w-full">
  <label>Ergebnis</label>
  <input type="text" id="result" class="p-inputtext w-full monospace" pInputText [value]="actionResponse?.result" />
</span>

<span class="inline-block mt-4 w-full">
  <label>Ausführungsdetails</label>
  <textarea
    pInputTextarea
    id="output"
    readonly
    class="w-full monospace"
    style="height: 615px; resize: none; white-space: pre"
    [value]="actionResponse?.output"
  ></textarea>
</span>
